module.exports = __webpack_public_path__ + "components/buttons/static/mountain-forecast__logo--white-5423364815dc724cb9b478c6f0fa0e2a.svg";